module.exports = __webpack_public_path__ + "img/肌如初雪套装_06.314100d5.jpg";